
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {ManagerGroupModifyResponse} from './ManagerGroupModifyResponse';
import {RightsMode} from '../core/RightsMode';
import {FieldModelRightsMode} from '../core/RightsMode';
import {ManagerRight} from '../core/ManagerRight';
import {FieldModelManagerRight} from '../core/ManagerRight';

/**
 * ManagerGroupModifyRequest struct
 */
class ManagerGroupModifyRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {UUID=} managerGroupId
   * @param {string=} managerGroupName
   * @param {number=} newSortOrder
   * @param {string=} newName
   * @param {string=} newComment
   * @param {string=} newDescription
   * @param {boolean=} newIsEnabled
   * @param {boolean=} newIsOTPEnabled
   * @param {!Array=} newAccessibleAccountGroups
   * @param {!boolean=} accessibleAccountGroupsReset
   * @param {!Array=} newAccessibleSymbolGroups
   * @param {!boolean=} accessibleSymbolGroupsReset
   * @param {RightsMode=} newAccountsRights
   * @param {RightsMode=} newSymbolsRights
   * @param {RightsMode=} newSystemRights
   * @param {RightsMode=} newModulesRights
   * @param {RightsMode=} newPlatformsRights
   * @param {RightsMode=} newManagersRights
   * @param {RightsMode=} newCurrenciesRights
   * @param {RightsMode=} newCalendarsRights
   * @param {RightsMode=} newProfilesRights
   * @param {RightsMode=} newDataFeedsRights
   * @param {RightsMode=} newGatewaysRights
   * @param {RightsMode=} newTradingRoutesRights
   * @param {RightsMode=} newQuotesHistoryRights
   * @param {RightsMode=} newReportsRights
   * @param {RightsMode=} newMonitoringRights
   * @param {!Set=} newRights
   * @param {UUID=} newPlatformId
   * @param {string=} newPlatformName
   * @param {RightsMode=} newPersonsRights
   * @param {RightsMode=} newSecuritySettingsRights
   * @param {RightsMode=} newFirewallRulesRights
   * @param {RightsMode=} newDocumentsRights
   * @param {RightsMode=} newSwapSettingsProfilesRights
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), managerGroupId = null, managerGroupName = null, newSortOrder = null, newName = null, newComment = null, newDescription = null, newIsEnabled = null, newIsOTPEnabled = null, newAccessibleAccountGroups = [], accessibleAccountGroupsReset = false, newAccessibleSymbolGroups = [], accessibleSymbolGroupsReset = false, newAccountsRights = null, newSymbolsRights = null, newSystemRights = null, newModulesRights = null, newPlatformsRights = null, newManagersRights = null, newCurrenciesRights = null, newCalendarsRights = null, newProfilesRights = null, newDataFeedsRights = null, newGatewaysRights = null, newTradingRoutesRights = null, newQuotesHistoryRights = null, newReportsRights = null, newMonitoringRights = null, newRights = new Set(), newPlatformId = null, newPlatformName = null, newPersonsRights = null, newSecuritySettingsRights = null, newFirewallRulesRights = null, newDocumentsRights = null, newSwapSettingsProfilesRights = null) {
    super()
    super.copy(parent)
    this.ManagerGroupId = managerGroupId
    this.ManagerGroupName = managerGroupName
    this.NewSortOrder = newSortOrder
    this.NewName = newName
    this.NewComment = newComment
    this.NewDescription = newDescription
    this.NewIsEnabled = newIsEnabled
    this.NewIsOTPEnabled = newIsOTPEnabled
    this.NewAccessibleAccountGroups = newAccessibleAccountGroups
    this.AccessibleAccountGroupsReset = accessibleAccountGroupsReset
    this.NewAccessibleSymbolGroups = newAccessibleSymbolGroups
    this.AccessibleSymbolGroupsReset = accessibleSymbolGroupsReset
    this.NewAccountsRights = newAccountsRights
    this.NewSymbolsRights = newSymbolsRights
    this.NewSystemRights = newSystemRights
    this.NewModulesRights = newModulesRights
    this.NewPlatformsRights = newPlatformsRights
    this.NewManagersRights = newManagersRights
    this.NewCurrenciesRights = newCurrenciesRights
    this.NewCalendarsRights = newCalendarsRights
    this.NewProfilesRights = newProfilesRights
    this.NewDataFeedsRights = newDataFeedsRights
    this.NewGatewaysRights = newGatewaysRights
    this.NewTradingRoutesRights = newTradingRoutesRights
    this.NewQuotesHistoryRights = newQuotesHistoryRights
    this.NewReportsRights = newReportsRights
    this.NewMonitoringRights = newMonitoringRights
    this.NewRights = newRights
    this.NewPlatformId = newPlatformId
    this.NewPlatformName = newPlatformName
    this.NewPersonsRights = newPersonsRights
    this.NewSecuritySettingsRights = newSecuritySettingsRights
    this.NewFirewallRulesRights = newFirewallRulesRights
    this.NewDocumentsRights = newDocumentsRights
    this.NewSwapSettingsProfilesRights = newSwapSettingsProfilesRights
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ManagerGroupModifyRequest}
   * @param {!ManagerGroupModifyRequest} other Other struct
   * @returns {!ManagerGroupModifyRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ManagerGroupId != null) {
      this.ManagerGroupId = new UUID(other.ManagerGroupId)
    } else {
      this.ManagerGroupId = null
    }
    if (other.ManagerGroupName != null) {
      this.ManagerGroupName = other.ManagerGroupName
    } else {
      this.ManagerGroupName = null
    }
    if (other.NewSortOrder != null) {
      this.NewSortOrder = other.NewSortOrder
    } else {
      this.NewSortOrder = null
    }
    if (other.NewName != null) {
      this.NewName = other.NewName
    } else {
      this.NewName = null
    }
    if (other.NewComment != null) {
      this.NewComment = other.NewComment
    } else {
      this.NewComment = null
    }
    if (other.NewDescription != null) {
      this.NewDescription = other.NewDescription
    } else {
      this.NewDescription = null
    }
    if (other.NewIsEnabled != null) {
      this.NewIsEnabled = other.NewIsEnabled
    } else {
      this.NewIsEnabled = null
    }
    if (other.NewIsOTPEnabled != null) {
      this.NewIsOTPEnabled = other.NewIsOTPEnabled
    } else {
      this.NewIsOTPEnabled = null
    }
    if (other.NewAccessibleAccountGroups != null) {
      this.NewAccessibleAccountGroups = []
      for (let item of other.NewAccessibleAccountGroups) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.NewAccessibleAccountGroups.push(tempItem)
        } else {
          this.NewAccessibleAccountGroups.push(null)
        }
      }
    } else {
      this.NewAccessibleAccountGroups = null
    }
    if (other.AccessibleAccountGroupsReset != null) {
      this.AccessibleAccountGroupsReset = other.AccessibleAccountGroupsReset
    } else {
      this.AccessibleAccountGroupsReset = null
    }
    if (other.NewAccessibleSymbolGroups != null) {
      this.NewAccessibleSymbolGroups = []
      for (let item of other.NewAccessibleSymbolGroups) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.NewAccessibleSymbolGroups.push(tempItem)
        } else {
          this.NewAccessibleSymbolGroups.push(null)
        }
      }
    } else {
      this.NewAccessibleSymbolGroups = null
    }
    if (other.AccessibleSymbolGroupsReset != null) {
      this.AccessibleSymbolGroupsReset = other.AccessibleSymbolGroupsReset
    } else {
      this.AccessibleSymbolGroupsReset = null
    }
    if (other.NewAccountsRights != null) {
      this.NewAccountsRights = RightsMode.fromObject(other.NewAccountsRights)
    } else {
      this.NewAccountsRights = null
    }
    if (other.NewSymbolsRights != null) {
      this.NewSymbolsRights = RightsMode.fromObject(other.NewSymbolsRights)
    } else {
      this.NewSymbolsRights = null
    }
    if (other.NewSystemRights != null) {
      this.NewSystemRights = RightsMode.fromObject(other.NewSystemRights)
    } else {
      this.NewSystemRights = null
    }
    if (other.NewModulesRights != null) {
      this.NewModulesRights = RightsMode.fromObject(other.NewModulesRights)
    } else {
      this.NewModulesRights = null
    }
    if (other.NewPlatformsRights != null) {
      this.NewPlatformsRights = RightsMode.fromObject(other.NewPlatformsRights)
    } else {
      this.NewPlatformsRights = null
    }
    if (other.NewManagersRights != null) {
      this.NewManagersRights = RightsMode.fromObject(other.NewManagersRights)
    } else {
      this.NewManagersRights = null
    }
    if (other.NewCurrenciesRights != null) {
      this.NewCurrenciesRights = RightsMode.fromObject(other.NewCurrenciesRights)
    } else {
      this.NewCurrenciesRights = null
    }
    if (other.NewCalendarsRights != null) {
      this.NewCalendarsRights = RightsMode.fromObject(other.NewCalendarsRights)
    } else {
      this.NewCalendarsRights = null
    }
    if (other.NewProfilesRights != null) {
      this.NewProfilesRights = RightsMode.fromObject(other.NewProfilesRights)
    } else {
      this.NewProfilesRights = null
    }
    if (other.NewDataFeedsRights != null) {
      this.NewDataFeedsRights = RightsMode.fromObject(other.NewDataFeedsRights)
    } else {
      this.NewDataFeedsRights = null
    }
    if (other.NewGatewaysRights != null) {
      this.NewGatewaysRights = RightsMode.fromObject(other.NewGatewaysRights)
    } else {
      this.NewGatewaysRights = null
    }
    if (other.NewTradingRoutesRights != null) {
      this.NewTradingRoutesRights = RightsMode.fromObject(other.NewTradingRoutesRights)
    } else {
      this.NewTradingRoutesRights = null
    }
    if (other.NewQuotesHistoryRights != null) {
      this.NewQuotesHistoryRights = RightsMode.fromObject(other.NewQuotesHistoryRights)
    } else {
      this.NewQuotesHistoryRights = null
    }
    if (other.NewReportsRights != null) {
      this.NewReportsRights = RightsMode.fromObject(other.NewReportsRights)
    } else {
      this.NewReportsRights = null
    }
    if (other.NewMonitoringRights != null) {
      this.NewMonitoringRights = RightsMode.fromObject(other.NewMonitoringRights)
    } else {
      this.NewMonitoringRights = null
    }
    if (other.NewRights != null) {
      this.NewRights = new Set()
      for (let item of other.NewRights) {
        if (item != null) {
          let tempItem
          tempItem = ManagerRight.fromObject(item)
          this.NewRights.add(tempItem)
        } else {
          this.NewRights.add(null)
        }
      }
    } else {
      this.NewRights = null
    }
    if (other.NewPlatformId != null) {
      this.NewPlatformId = new UUID(other.NewPlatformId)
    } else {
      this.NewPlatformId = null
    }
    if (other.NewPlatformName != null) {
      this.NewPlatformName = other.NewPlatformName
    } else {
      this.NewPlatformName = null
    }
    if (other.NewPersonsRights != null) {
      this.NewPersonsRights = RightsMode.fromObject(other.NewPersonsRights)
    } else {
      this.NewPersonsRights = null
    }
    if (other.NewSecuritySettingsRights != null) {
      this.NewSecuritySettingsRights = RightsMode.fromObject(other.NewSecuritySettingsRights)
    } else {
      this.NewSecuritySettingsRights = null
    }
    if (other.NewFirewallRulesRights != null) {
      this.NewFirewallRulesRights = RightsMode.fromObject(other.NewFirewallRulesRights)
    } else {
      this.NewFirewallRulesRights = null
    }
    if (other.NewDocumentsRights != null) {
      this.NewDocumentsRights = RightsMode.fromObject(other.NewDocumentsRights)
    } else {
      this.NewDocumentsRights = null
    }
    if (other.NewSwapSettingsProfilesRights != null) {
      this.NewSwapSettingsProfilesRights = RightsMode.fromObject(other.NewSwapSettingsProfilesRights)
    } else {
      this.NewSwapSettingsProfilesRights = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ManagerGroupModifyRequest}
   * @returns {!ManagerGroupModifyRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ManagerGroupModifyRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ManagerGroupModifyRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ManagerGroupModifyRequest}
   * @param {!ManagerGroupModifyRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ManagerGroupModifyRequest)) {
      throw new TypeError('Instance of ManagerGroupModifyRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ManagerGroupModifyRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ManagerGroupId: ((this.ManagerGroupId != null) ? this.ManagerGroupId.toString() : null),
      ManagerGroupName: ((this.ManagerGroupName != null) ? this.ManagerGroupName : null),
      NewSortOrder: ((this.NewSortOrder != null) ? this.NewSortOrder : null),
      NewName: ((this.NewName != null) ? this.NewName : null),
      NewComment: ((this.NewComment != null) ? this.NewComment : null),
      NewDescription: ((this.NewDescription != null) ? this.NewDescription : null),
      NewIsEnabled: ((this.NewIsEnabled != null) ? this.NewIsEnabled : null),
      NewIsOTPEnabled: ((this.NewIsOTPEnabled != null) ? this.NewIsOTPEnabled : null),
      NewAccessibleAccountGroups: ((this.NewAccessibleAccountGroups != null) ? Array.from(this.NewAccessibleAccountGroups, item => ((item != null) ? item : null)) : null),
      AccessibleAccountGroupsReset: ((this.AccessibleAccountGroupsReset != null) ? this.AccessibleAccountGroupsReset : null),
      NewAccessibleSymbolGroups: ((this.NewAccessibleSymbolGroups != null) ? Array.from(this.NewAccessibleSymbolGroups, item => ((item != null) ? item : null)) : null),
      AccessibleSymbolGroupsReset: ((this.AccessibleSymbolGroupsReset != null) ? this.AccessibleSymbolGroupsReset : null),
      NewAccountsRights: ((this.NewAccountsRights != null) ? this.NewAccountsRights : null),
      NewSymbolsRights: ((this.NewSymbolsRights != null) ? this.NewSymbolsRights : null),
      NewSystemRights: ((this.NewSystemRights != null) ? this.NewSystemRights : null),
      NewModulesRights: ((this.NewModulesRights != null) ? this.NewModulesRights : null),
      NewPlatformsRights: ((this.NewPlatformsRights != null) ? this.NewPlatformsRights : null),
      NewManagersRights: ((this.NewManagersRights != null) ? this.NewManagersRights : null),
      NewCurrenciesRights: ((this.NewCurrenciesRights != null) ? this.NewCurrenciesRights : null),
      NewCalendarsRights: ((this.NewCalendarsRights != null) ? this.NewCalendarsRights : null),
      NewProfilesRights: ((this.NewProfilesRights != null) ? this.NewProfilesRights : null),
      NewDataFeedsRights: ((this.NewDataFeedsRights != null) ? this.NewDataFeedsRights : null),
      NewGatewaysRights: ((this.NewGatewaysRights != null) ? this.NewGatewaysRights : null),
      NewTradingRoutesRights: ((this.NewTradingRoutesRights != null) ? this.NewTradingRoutesRights : null),
      NewQuotesHistoryRights: ((this.NewQuotesHistoryRights != null) ? this.NewQuotesHistoryRights : null),
      NewReportsRights: ((this.NewReportsRights != null) ? this.NewReportsRights : null),
      NewMonitoringRights: ((this.NewMonitoringRights != null) ? this.NewMonitoringRights : null),
      NewRights: ((this.NewRights != null) ? Array.from(this.NewRights, item => ((item != null) ? item : null)) : null),
      NewPlatformId: ((this.NewPlatformId != null) ? this.NewPlatformId.toString() : null),
      NewPlatformName: ((this.NewPlatformName != null) ? this.NewPlatformName : null),
      NewPersonsRights: ((this.NewPersonsRights != null) ? this.NewPersonsRights : null),
      NewSecuritySettingsRights: ((this.NewSecuritySettingsRights != null) ? this.NewSecuritySettingsRights : null),
      NewFirewallRulesRights: ((this.NewFirewallRulesRights != null) ? this.NewFirewallRulesRights : null),
      NewDocumentsRights: ((this.NewDocumentsRights != null) ? this.NewDocumentsRights : null),
      NewSwapSettingsProfilesRights: ((this.NewSwapSettingsProfilesRights != null) ? this.NewSwapSettingsProfilesRights : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ManagerGroupModifyRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ManagerGroupModifyRequest} other Object value
   * @returns {!ManagerGroupModifyRequest} Created struct
   */
  static fromObject (other) {
    return new ManagerGroupModifyRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ManagerGroupModifyRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ManagerGroupModifyRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ManagerGroupModifyRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6150
  }
}

export { ManagerGroupModifyRequest };

/**
 * Fast Binary Encoding ManagerGroupModifyRequest field model
 */
class FieldModelManagerGroupModifyRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.ManagerGroupId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ManagerGroupName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ManagerGroupId.fbeOffset + this.ManagerGroupId.fbeSize), buffer, this.ManagerGroupId.fbeOffset + this.ManagerGroupId.fbeSize)
    this.NewSortOrder = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.ManagerGroupName.fbeOffset + this.ManagerGroupName.fbeSize), buffer, this.ManagerGroupName.fbeOffset + this.ManagerGroupName.fbeSize)
    this.NewName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize), buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize)
    this.NewComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewName.fbeOffset + this.NewName.fbeSize), buffer, this.NewName.fbeOffset + this.NewName.fbeSize)
    this.NewDescription = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize), buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize)
    this.NewIsEnabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize), buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize)
    this.NewIsOTPEnabled = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.NewIsEnabled.fbeOffset + this.NewIsEnabled.fbeSize), buffer, this.NewIsEnabled.fbeOffset + this.NewIsEnabled.fbeSize)
    this.NewAccessibleAccountGroups = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this.NewIsOTPEnabled.fbeOffset + this.NewIsOTPEnabled.fbeSize), buffer, this.NewIsOTPEnabled.fbeOffset + this.NewIsOTPEnabled.fbeSize)
    this.AccessibleAccountGroupsReset = new fbe.FieldModelBool(buffer, this.NewAccessibleAccountGroups.fbeOffset + this.NewAccessibleAccountGroups.fbeSize)
    this.NewAccessibleSymbolGroups = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this.AccessibleAccountGroupsReset.fbeOffset + this.AccessibleAccountGroupsReset.fbeSize), buffer, this.AccessibleAccountGroupsReset.fbeOffset + this.AccessibleAccountGroupsReset.fbeSize)
    this.AccessibleSymbolGroupsReset = new fbe.FieldModelBool(buffer, this.NewAccessibleSymbolGroups.fbeOffset + this.NewAccessibleSymbolGroups.fbeSize)
    this.NewAccountsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.AccessibleSymbolGroupsReset.fbeOffset + this.AccessibleSymbolGroupsReset.fbeSize), buffer, this.AccessibleSymbolGroupsReset.fbeOffset + this.AccessibleSymbolGroupsReset.fbeSize)
    this.NewSymbolsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewAccountsRights.fbeOffset + this.NewAccountsRights.fbeSize), buffer, this.NewAccountsRights.fbeOffset + this.NewAccountsRights.fbeSize)
    this.NewSystemRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewSymbolsRights.fbeOffset + this.NewSymbolsRights.fbeSize), buffer, this.NewSymbolsRights.fbeOffset + this.NewSymbolsRights.fbeSize)
    this.NewModulesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewSystemRights.fbeOffset + this.NewSystemRights.fbeSize), buffer, this.NewSystemRights.fbeOffset + this.NewSystemRights.fbeSize)
    this.NewPlatformsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewModulesRights.fbeOffset + this.NewModulesRights.fbeSize), buffer, this.NewModulesRights.fbeOffset + this.NewModulesRights.fbeSize)
    this.NewManagersRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewPlatformsRights.fbeOffset + this.NewPlatformsRights.fbeSize), buffer, this.NewPlatformsRights.fbeOffset + this.NewPlatformsRights.fbeSize)
    this.NewCurrenciesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewManagersRights.fbeOffset + this.NewManagersRights.fbeSize), buffer, this.NewManagersRights.fbeOffset + this.NewManagersRights.fbeSize)
    this.NewCalendarsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewCurrenciesRights.fbeOffset + this.NewCurrenciesRights.fbeSize), buffer, this.NewCurrenciesRights.fbeOffset + this.NewCurrenciesRights.fbeSize)
    this.NewProfilesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewCalendarsRights.fbeOffset + this.NewCalendarsRights.fbeSize), buffer, this.NewCalendarsRights.fbeOffset + this.NewCalendarsRights.fbeSize)
    this.NewDataFeedsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewProfilesRights.fbeOffset + this.NewProfilesRights.fbeSize), buffer, this.NewProfilesRights.fbeOffset + this.NewProfilesRights.fbeSize)
    this.NewGatewaysRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewDataFeedsRights.fbeOffset + this.NewDataFeedsRights.fbeSize), buffer, this.NewDataFeedsRights.fbeOffset + this.NewDataFeedsRights.fbeSize)
    this.NewTradingRoutesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewGatewaysRights.fbeOffset + this.NewGatewaysRights.fbeSize), buffer, this.NewGatewaysRights.fbeOffset + this.NewGatewaysRights.fbeSize)
    this.NewQuotesHistoryRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewTradingRoutesRights.fbeOffset + this.NewTradingRoutesRights.fbeSize), buffer, this.NewTradingRoutesRights.fbeOffset + this.NewTradingRoutesRights.fbeSize)
    this.NewReportsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewQuotesHistoryRights.fbeOffset + this.NewQuotesHistoryRights.fbeSize), buffer, this.NewQuotesHistoryRights.fbeOffset + this.NewQuotesHistoryRights.fbeSize)
    this.NewMonitoringRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewReportsRights.fbeOffset + this.NewReportsRights.fbeSize), buffer, this.NewReportsRights.fbeOffset + this.NewReportsRights.fbeSize)
    this.NewRights = new fbe.FieldModelSet(new FieldModelManagerRight(buffer, this.NewMonitoringRights.fbeOffset + this.NewMonitoringRights.fbeSize), buffer, this.NewMonitoringRights.fbeOffset + this.NewMonitoringRights.fbeSize)
    this.NewPlatformId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.NewRights.fbeOffset + this.NewRights.fbeSize), buffer, this.NewRights.fbeOffset + this.NewRights.fbeSize)
    this.NewPlatformName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewPlatformId.fbeOffset + this.NewPlatformId.fbeSize), buffer, this.NewPlatformId.fbeOffset + this.NewPlatformId.fbeSize)
    this.NewPersonsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewPlatformName.fbeOffset + this.NewPlatformName.fbeSize), buffer, this.NewPlatformName.fbeOffset + this.NewPlatformName.fbeSize)
    this.NewSecuritySettingsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewPersonsRights.fbeOffset + this.NewPersonsRights.fbeSize), buffer, this.NewPersonsRights.fbeOffset + this.NewPersonsRights.fbeSize)
    this.NewFirewallRulesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewSecuritySettingsRights.fbeOffset + this.NewSecuritySettingsRights.fbeSize), buffer, this.NewSecuritySettingsRights.fbeOffset + this.NewSecuritySettingsRights.fbeSize)
    this.NewDocumentsRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewFirewallRulesRights.fbeOffset + this.NewFirewallRulesRights.fbeSize), buffer, this.NewFirewallRulesRights.fbeOffset + this.NewFirewallRulesRights.fbeSize)
    this.NewSwapSettingsProfilesRights = new fbe.FieldModelOptional(new FieldModelRightsMode(buffer, this.NewDocumentsRights.fbeOffset + this.NewDocumentsRights.fbeSize), buffer, this.NewDocumentsRights.fbeOffset + this.NewDocumentsRights.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ManagerGroupId.fbeSize + this.ManagerGroupName.fbeSize + this.NewSortOrder.fbeSize + this.NewName.fbeSize + this.NewComment.fbeSize + this.NewDescription.fbeSize + this.NewIsEnabled.fbeSize + this.NewIsOTPEnabled.fbeSize + this.NewAccessibleAccountGroups.fbeSize + this.AccessibleAccountGroupsReset.fbeSize + this.NewAccessibleSymbolGroups.fbeSize + this.AccessibleSymbolGroupsReset.fbeSize + this.NewAccountsRights.fbeSize + this.NewSymbolsRights.fbeSize + this.NewSystemRights.fbeSize + this.NewModulesRights.fbeSize + this.NewPlatformsRights.fbeSize + this.NewManagersRights.fbeSize + this.NewCurrenciesRights.fbeSize + this.NewCalendarsRights.fbeSize + this.NewProfilesRights.fbeSize + this.NewDataFeedsRights.fbeSize + this.NewGatewaysRights.fbeSize + this.NewTradingRoutesRights.fbeSize + this.NewQuotesHistoryRights.fbeSize + this.NewReportsRights.fbeSize + this.NewMonitoringRights.fbeSize + this.NewRights.fbeSize + this.NewPlatformId.fbeSize + this.NewPlatformName.fbeSize + this.NewPersonsRights.fbeSize + this.NewSecuritySettingsRights.fbeSize + this.NewFirewallRulesRights.fbeSize + this.NewDocumentsRights.fbeSize + this.NewSwapSettingsProfilesRights.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ManagerGroupId.fbeExtra + this.ManagerGroupName.fbeExtra + this.NewSortOrder.fbeExtra + this.NewName.fbeExtra + this.NewComment.fbeExtra + this.NewDescription.fbeExtra + this.NewIsEnabled.fbeExtra + this.NewIsOTPEnabled.fbeExtra + this.NewAccessibleAccountGroups.fbeExtra + this.AccessibleAccountGroupsReset.fbeExtra + this.NewAccessibleSymbolGroups.fbeExtra + this.AccessibleSymbolGroupsReset.fbeExtra + this.NewAccountsRights.fbeExtra + this.NewSymbolsRights.fbeExtra + this.NewSystemRights.fbeExtra + this.NewModulesRights.fbeExtra + this.NewPlatformsRights.fbeExtra + this.NewManagersRights.fbeExtra + this.NewCurrenciesRights.fbeExtra + this.NewCalendarsRights.fbeExtra + this.NewProfilesRights.fbeExtra + this.NewDataFeedsRights.fbeExtra + this.NewGatewaysRights.fbeExtra + this.NewTradingRoutesRights.fbeExtra + this.NewQuotesHistoryRights.fbeExtra + this.NewReportsRights.fbeExtra + this.NewMonitoringRights.fbeExtra + this.NewRights.fbeExtra + this.NewPlatformId.fbeExtra + this.NewPlatformName.fbeExtra + this.NewPersonsRights.fbeExtra + this.NewSecuritySettingsRights.fbeExtra + this.NewFirewallRulesRights.fbeExtra + this.NewDocumentsRights.fbeExtra + this.NewSwapSettingsProfilesRights.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelManagerGroupModifyRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6150
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ManagerGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerGroupId.fbeSize

    if ((fbeCurrentSize + this.ManagerGroupName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerGroupName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerGroupName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDescription.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewIsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewIsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsEnabled.fbeSize

    if ((fbeCurrentSize + this.NewIsOTPEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewIsOTPEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.NewAccessibleAccountGroups.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewAccessibleAccountGroups.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccessibleAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccessibleAccountGroupsReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccessibleAccountGroupsReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccessibleAccountGroupsReset.fbeSize

    if ((fbeCurrentSize + this.NewAccessibleSymbolGroups.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewAccessibleSymbolGroups.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccessibleSymbolGroups.fbeSize

    if ((fbeCurrentSize + this.AccessibleSymbolGroupsReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccessibleSymbolGroupsReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccessibleSymbolGroupsReset.fbeSize

    if ((fbeCurrentSize + this.NewAccountsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewAccountsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccountsRights.fbeSize

    if ((fbeCurrentSize + this.NewSymbolsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSymbolsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSymbolsRights.fbeSize

    if ((fbeCurrentSize + this.NewSystemRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSystemRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSystemRights.fbeSize

    if ((fbeCurrentSize + this.NewModulesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewModulesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewModulesRights.fbeSize

    if ((fbeCurrentSize + this.NewPlatformsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewPlatformsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformsRights.fbeSize

    if ((fbeCurrentSize + this.NewManagersRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewManagersRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewManagersRights.fbeSize

    if ((fbeCurrentSize + this.NewCurrenciesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewCurrenciesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCurrenciesRights.fbeSize

    if ((fbeCurrentSize + this.NewCalendarsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewCalendarsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCalendarsRights.fbeSize

    if ((fbeCurrentSize + this.NewProfilesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewProfilesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewProfilesRights.fbeSize

    if ((fbeCurrentSize + this.NewDataFeedsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDataFeedsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDataFeedsRights.fbeSize

    if ((fbeCurrentSize + this.NewGatewaysRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewGatewaysRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewaysRights.fbeSize

    if ((fbeCurrentSize + this.NewTradingRoutesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewTradingRoutesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTradingRoutesRights.fbeSize

    if ((fbeCurrentSize + this.NewQuotesHistoryRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewQuotesHistoryRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewQuotesHistoryRights.fbeSize

    if ((fbeCurrentSize + this.NewReportsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewReportsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewReportsRights.fbeSize

    if ((fbeCurrentSize + this.NewMonitoringRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMonitoringRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMonitoringRights.fbeSize

    if ((fbeCurrentSize + this.NewRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewRights.fbeSize

    if ((fbeCurrentSize + this.NewPlatformId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewPlatformId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformId.fbeSize

    if ((fbeCurrentSize + this.NewPlatformName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewPlatformName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformName.fbeSize

    if ((fbeCurrentSize + this.NewPersonsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewPersonsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPersonsRights.fbeSize

    if ((fbeCurrentSize + this.NewSecuritySettingsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSecuritySettingsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSecuritySettingsRights.fbeSize

    if ((fbeCurrentSize + this.NewFirewallRulesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewFirewallRulesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewFirewallRulesRights.fbeSize

    if ((fbeCurrentSize + this.NewDocumentsRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDocumentsRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDocumentsRights.fbeSize

    if ((fbeCurrentSize + this.NewSwapSettingsProfilesRights.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSwapSettingsProfilesRights.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSwapSettingsProfilesRights.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!ManagerGroupModifyRequest} fbeValue Default value, defaults is new ManagerGroupModifyRequest()
   * @returns {!ManagerGroupModifyRequest} ManagerGroupModifyRequest value
   */
  get (fbeValue = new ManagerGroupModifyRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!ManagerGroupModifyRequest} fbeValue ManagerGroupModifyRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ManagerGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerGroupId = this.ManagerGroupId.get()
    } else {
      fbeValue.ManagerGroupId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerGroupId.fbeSize

    if ((fbeCurrentSize + this.ManagerGroupName.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerGroupName = this.ManagerGroupName.get()
    } else {
      fbeValue.ManagerGroupName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerGroupName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.NewSortOrder = this.NewSortOrder.get()
    } else {
      fbeValue.NewSortOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) <= fbeStructSize) {
      fbeValue.NewName = this.NewName.get()
    } else {
      fbeValue.NewName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) <= fbeStructSize) {
      fbeValue.NewComment = this.NewComment.get()
    } else {
      fbeValue.NewComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) <= fbeStructSize) {
      fbeValue.NewDescription = this.NewDescription.get()
    } else {
      fbeValue.NewDescription = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewIsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.NewIsEnabled = this.NewIsEnabled.get()
    } else {
      fbeValue.NewIsEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsEnabled.fbeSize

    if ((fbeCurrentSize + this.NewIsOTPEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.NewIsOTPEnabled = this.NewIsOTPEnabled.get()
    } else {
      fbeValue.NewIsOTPEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.NewAccessibleAccountGroups.fbeSize) <= fbeStructSize) {
      this.NewAccessibleAccountGroups.get(fbeValue.NewAccessibleAccountGroups)
    } else {
      fbeValue.NewAccessibleAccountGroups.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccessibleAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccessibleAccountGroupsReset.fbeSize) <= fbeStructSize) {
      fbeValue.AccessibleAccountGroupsReset = this.AccessibleAccountGroupsReset.get()
    } else {
      fbeValue.AccessibleAccountGroupsReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccessibleAccountGroupsReset.fbeSize

    if ((fbeCurrentSize + this.NewAccessibleSymbolGroups.fbeSize) <= fbeStructSize) {
      this.NewAccessibleSymbolGroups.get(fbeValue.NewAccessibleSymbolGroups)
    } else {
      fbeValue.NewAccessibleSymbolGroups.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccessibleSymbolGroups.fbeSize

    if ((fbeCurrentSize + this.AccessibleSymbolGroupsReset.fbeSize) <= fbeStructSize) {
      fbeValue.AccessibleSymbolGroupsReset = this.AccessibleSymbolGroupsReset.get()
    } else {
      fbeValue.AccessibleSymbolGroupsReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccessibleSymbolGroupsReset.fbeSize

    if ((fbeCurrentSize + this.NewAccountsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewAccountsRights = this.NewAccountsRights.get()
    } else {
      fbeValue.NewAccountsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewAccountsRights.fbeSize

    if ((fbeCurrentSize + this.NewSymbolsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewSymbolsRights = this.NewSymbolsRights.get()
    } else {
      fbeValue.NewSymbolsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSymbolsRights.fbeSize

    if ((fbeCurrentSize + this.NewSystemRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewSystemRights = this.NewSystemRights.get()
    } else {
      fbeValue.NewSystemRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSystemRights.fbeSize

    if ((fbeCurrentSize + this.NewModulesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewModulesRights = this.NewModulesRights.get()
    } else {
      fbeValue.NewModulesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewModulesRights.fbeSize

    if ((fbeCurrentSize + this.NewPlatformsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewPlatformsRights = this.NewPlatformsRights.get()
    } else {
      fbeValue.NewPlatformsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformsRights.fbeSize

    if ((fbeCurrentSize + this.NewManagersRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewManagersRights = this.NewManagersRights.get()
    } else {
      fbeValue.NewManagersRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewManagersRights.fbeSize

    if ((fbeCurrentSize + this.NewCurrenciesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewCurrenciesRights = this.NewCurrenciesRights.get()
    } else {
      fbeValue.NewCurrenciesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCurrenciesRights.fbeSize

    if ((fbeCurrentSize + this.NewCalendarsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewCalendarsRights = this.NewCalendarsRights.get()
    } else {
      fbeValue.NewCalendarsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewCalendarsRights.fbeSize

    if ((fbeCurrentSize + this.NewProfilesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewProfilesRights = this.NewProfilesRights.get()
    } else {
      fbeValue.NewProfilesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewProfilesRights.fbeSize

    if ((fbeCurrentSize + this.NewDataFeedsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewDataFeedsRights = this.NewDataFeedsRights.get()
    } else {
      fbeValue.NewDataFeedsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDataFeedsRights.fbeSize

    if ((fbeCurrentSize + this.NewGatewaysRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewGatewaysRights = this.NewGatewaysRights.get()
    } else {
      fbeValue.NewGatewaysRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewGatewaysRights.fbeSize

    if ((fbeCurrentSize + this.NewTradingRoutesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewTradingRoutesRights = this.NewTradingRoutesRights.get()
    } else {
      fbeValue.NewTradingRoutesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewTradingRoutesRights.fbeSize

    if ((fbeCurrentSize + this.NewQuotesHistoryRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewQuotesHistoryRights = this.NewQuotesHistoryRights.get()
    } else {
      fbeValue.NewQuotesHistoryRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewQuotesHistoryRights.fbeSize

    if ((fbeCurrentSize + this.NewReportsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewReportsRights = this.NewReportsRights.get()
    } else {
      fbeValue.NewReportsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewReportsRights.fbeSize

    if ((fbeCurrentSize + this.NewMonitoringRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewMonitoringRights = this.NewMonitoringRights.get()
    } else {
      fbeValue.NewMonitoringRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMonitoringRights.fbeSize

    if ((fbeCurrentSize + this.NewRights.fbeSize) <= fbeStructSize) {
      this.NewRights.get(fbeValue.NewRights)
    } else {
      fbeValue.NewRights.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewRights.fbeSize

    if ((fbeCurrentSize + this.NewPlatformId.fbeSize) <= fbeStructSize) {
      fbeValue.NewPlatformId = this.NewPlatformId.get()
    } else {
      fbeValue.NewPlatformId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformId.fbeSize

    if ((fbeCurrentSize + this.NewPlatformName.fbeSize) <= fbeStructSize) {
      fbeValue.NewPlatformName = this.NewPlatformName.get()
    } else {
      fbeValue.NewPlatformName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPlatformName.fbeSize

    if ((fbeCurrentSize + this.NewPersonsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewPersonsRights = this.NewPersonsRights.get()
    } else {
      fbeValue.NewPersonsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewPersonsRights.fbeSize

    if ((fbeCurrentSize + this.NewSecuritySettingsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewSecuritySettingsRights = this.NewSecuritySettingsRights.get()
    } else {
      fbeValue.NewSecuritySettingsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSecuritySettingsRights.fbeSize

    if ((fbeCurrentSize + this.NewFirewallRulesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewFirewallRulesRights = this.NewFirewallRulesRights.get()
    } else {
      fbeValue.NewFirewallRulesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewFirewallRulesRights.fbeSize

    if ((fbeCurrentSize + this.NewDocumentsRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewDocumentsRights = this.NewDocumentsRights.get()
    } else {
      fbeValue.NewDocumentsRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDocumentsRights.fbeSize

    if ((fbeCurrentSize + this.NewSwapSettingsProfilesRights.fbeSize) <= fbeStructSize) {
      fbeValue.NewSwapSettingsProfilesRights = this.NewSwapSettingsProfilesRights.get()
    } else {
      fbeValue.NewSwapSettingsProfilesRights = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSwapSettingsProfilesRights.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelManagerGroupModifyRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {!ManagerGroupModifyRequest} fbeValue ManagerGroupModifyRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelManagerGroupModifyRequest}
   * @param {ManagerGroupModifyRequest} fbeValue ManagerGroupModifyRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ManagerGroupId.set(fbeValue.ManagerGroupId)
    this.ManagerGroupName.set(fbeValue.ManagerGroupName)
    this.NewSortOrder.set(fbeValue.NewSortOrder)
    this.NewName.set(fbeValue.NewName)
    this.NewComment.set(fbeValue.NewComment)
    this.NewDescription.set(fbeValue.NewDescription)
    this.NewIsEnabled.set(fbeValue.NewIsEnabled)
    this.NewIsOTPEnabled.set(fbeValue.NewIsOTPEnabled)
    this.NewAccessibleAccountGroups.set(fbeValue.NewAccessibleAccountGroups)
    this.AccessibleAccountGroupsReset.set(fbeValue.AccessibleAccountGroupsReset)
    this.NewAccessibleSymbolGroups.set(fbeValue.NewAccessibleSymbolGroups)
    this.AccessibleSymbolGroupsReset.set(fbeValue.AccessibleSymbolGroupsReset)
    this.NewAccountsRights.set(fbeValue.NewAccountsRights)
    this.NewSymbolsRights.set(fbeValue.NewSymbolsRights)
    this.NewSystemRights.set(fbeValue.NewSystemRights)
    this.NewModulesRights.set(fbeValue.NewModulesRights)
    this.NewPlatformsRights.set(fbeValue.NewPlatformsRights)
    this.NewManagersRights.set(fbeValue.NewManagersRights)
    this.NewCurrenciesRights.set(fbeValue.NewCurrenciesRights)
    this.NewCalendarsRights.set(fbeValue.NewCalendarsRights)
    this.NewProfilesRights.set(fbeValue.NewProfilesRights)
    this.NewDataFeedsRights.set(fbeValue.NewDataFeedsRights)
    this.NewGatewaysRights.set(fbeValue.NewGatewaysRights)
    this.NewTradingRoutesRights.set(fbeValue.NewTradingRoutesRights)
    this.NewQuotesHistoryRights.set(fbeValue.NewQuotesHistoryRights)
    this.NewReportsRights.set(fbeValue.NewReportsRights)
    this.NewMonitoringRights.set(fbeValue.NewMonitoringRights)
    this.NewRights.set(fbeValue.NewRights)
    this.NewPlatformId.set(fbeValue.NewPlatformId)
    this.NewPlatformName.set(fbeValue.NewPlatformName)
    this.NewPersonsRights.set(fbeValue.NewPersonsRights)
    this.NewSecuritySettingsRights.set(fbeValue.NewSecuritySettingsRights)
    this.NewFirewallRulesRights.set(fbeValue.NewFirewallRulesRights)
    this.NewDocumentsRights.set(fbeValue.NewDocumentsRights)
    this.NewSwapSettingsProfilesRights.set(fbeValue.NewSwapSettingsProfilesRights)
  }
}

export { FieldModelManagerGroupModifyRequest };

/**
 * Fast Binary Encoding ManagerGroupModifyRequest model
 */
class ManagerGroupModifyRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelManagerGroupModifyRequest(this.buffer, 4)
  }

  /**
   * Get the ManagerGroupModifyRequest model
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!FieldModelManagerGroupModifyRequest} model ManagerGroupModifyRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ManagerGroupModifyRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelManagerGroupModifyRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ManagerGroupModifyRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ManagerGroupModifyRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ManagerGroupModifyRequestModel}
   * @param {!ManagerGroupModifyRequest} value ManagerGroupModifyRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ManagerGroupModifyRequestModel}
   * @param {!ManagerGroupModifyRequest} value ManagerGroupModifyRequest value, defaults is new ManagerGroupModifyRequest()
   * @return {!object} Deserialized ManagerGroupModifyRequest value and its size
   */
  deserialize (value = new ManagerGroupModifyRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ManagerGroupModifyRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ManagerGroupModifyRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ManagerGroupModifyRequestModel}
   * @param {!number} prev Previous ManagerGroupModifyRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ManagerGroupModifyRequestModel };
ManagerGroupModifyRequest.__has_response = true;
ManagerGroupModifyRequest.__response_class = ManagerGroupModifyResponse;
